import { useEffect, useState } from 'react'

/**
 * Live "time remaining until targetIso" formatted as Jj Hh (a day out or more),
 * Hh MMm SSs (under a day), or MM:SS (under an hour). Returns 'Résolution…' once
 * the target is reached, '—' if null. Recomputes every second; cleans up on
 * unmount / target change.
 */
export function useCountdown(targetIso: string | null): string {
  const compute = (): string => {
    if (!targetIso) return '—'
    const ms = new Date(targetIso).getTime() - Date.now()
    if (ms <= 0) return 'Résolution…'
    const totalSec = Math.floor(ms / 1000)
    const d = Math.floor(totalSec / 86400)
    const h = Math.floor((totalSec % 86400) / 3600)
    const m = Math.floor((totalSec % 3600) / 60)
    const s = totalSec % 60
    const pad = (n: number) => n.toString().padStart(2, '0')
    if (d > 0) return `${d}j ${h}h`
    return h > 0 ? `${h}h ${pad(m)}m ${pad(s)}s` : `${pad(m)}:${pad(s)}`
  }

  const [text, setText] = useState(compute)

  useEffect(() => {
    if (!targetIso) return
    const id = window.setInterval(() => setText(compute()), 1000)
    return () => window.clearInterval(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetIso])

  return text
}
